import { Component, Input } from "@angular/core";
import { Products } from "../../../../models/product.model";
import { USER_ROLE, UserSession } from "../../../../models/user.model";
import { GridService } from "../../../../shared/services/utils/grid.service";
import { CartService } from "../../../../shared/services/order/cart.service";
import { RouterLink } from "@angular/router";
import { SharedModule } from "../../../../shared/shared.module";
import { formatUSD } from "../../../../consts/utils";
import { jwtDecode } from "jwt-decode";
import { localStorageConstants } from "../../../../consts/local_storage_constants";

@Component({
  selector: 'app-product-show',
  imports: [RouterLink, SharedModule],

  templateUrl: './product-show.component.html',
  styleUrl: './product-show.component.scss'
})
export class ProductShowComponent {

  @Input() productList: [Products];

  private userSession: UserSession;
  tokenInfo: any;


  constructor(
    private gridService: GridService,

    private _cartService: CartService
  ) { 
    const token: any = localStorage.getItem(localStorageConstants.PORTAL_TOKEN);
    this.tokenInfo = this.getDecodedAccessToken(token); 
  }

  public sidebaron: boolean = false;
  public listView: boolean = false;
  public col_xl_12: boolean = false;
  public col_xl_2: boolean = false;
  public col_sm_3: boolean = false;
  public col_xl_3: boolean = true;
  public xl_4: boolean = true;
  public col_sm_4: boolean = false;
  public col_xl_4: boolean = false;
  public col_sm_6: boolean = true;
  public col_xl_6: boolean = false;
  public gridOptions: boolean = true;
  public active: boolean = false;

  getDecodedAccessToken(token: string): any {
    try {
      return jwtDecode(token);
    } catch (Error) {
      return null;
    }
  }

  ngOnInit(): void {
    // let userSessionRecover: string | null = sessionStorage.getItem("user");
    // if (userSessionRecover == null) {
    //   return;
    // }
    // this.userSession = JSON.parse(userSessionRecover);

       
  }

  ngDoCheck() {
    this.col_xl_12 = this.gridService.col_xl_12;
    this.col_xl_2 = this.gridService.col_xl_2;
    this.col_sm_3 = this.gridService.col_xl_12;
    this.col_xl_3 = this.gridService.col_xl_3;
    this.xl_4 = this.gridService.xl_4;
    this.col_sm_4 = this.gridService.col_sm_4;
    this.col_xl_4 = this.gridService.col_xl_4;
    this.col_sm_6 = this.gridService.col_sm_6;
    this.col_xl_6 = this.gridService.col_xl_6;
  }

  validateNewProduct(creationDate: string): boolean {
    const creationDateObj = new Date(creationDate);
    const currentDate = new Date();

    // Define a threshold (e.g., 30 days) for considering a product "New"
    const THRESHOLD_DAYS = 30;
    const diffTime = Math.abs(currentDate.getTime() - creationDateObj.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays <= THRESHOLD_DAYS;
  }
  isTagAllowed(tags: any): boolean {
    if (!tags) return true; // Allow when tags are null/undefined
    const tagString = Array.isArray(tags) ? tags.join(",") : String(tags);
    return !tagString.toLowerCase().includes("refresh") &&
      !tagString.toLowerCase().includes("refresher");
  }
  formatDescription(description: string) {
    if (!this.col_xl_12)
      return description.substring(0, 20) + "...";
    else return description.substring(0, 100) + "...";;
  }

  calculateDiscount(price: string, discount: string) {
    return parseFloat(price) * parseFloat(discount);
  }

  createOrUpdateCart(productId: string) {
    if (this.tokenInfo && this.tokenInfo.role == USER_ROLE.COMPANY) {
      this._cartService.saveOrUpdateCart(undefined, this.tokenInfo?._id, productId, 1);      
    } else {
      this._cartService.saveOrUpdateCart(this.tokenInfo?._id, undefined, productId, 1);
    }
  }

  formatAmount(amount: any) {
    return formatUSD(amount);
  }

}
